
import { initializeApp } from "firebase/app";
import { getFirestore} from '@firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyCSBd41PYn4nAy8S8inqF0fADH00pjSC6I",
  authDomain: "portfolio-225f8.firebaseapp.com",
  projectId: "portfolio-225f8",
  storageBucket: "portfolio-225f8.appspot.com",
  messagingSenderId: "31492528705",
  appId: "1:31492528705:web:2e214d270afc5b9719c4c0",
  measurementId: "G-D5FS0W3GRW"
};


const app = initializeApp(firebaseConfig);
export const db = getFirestore(app)
